export default __webpack_public_path__ + "static/banner-contacto-c8ed6028331c341d6e09e5b0e576fc10.png";